module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Trash-6d92a8bee573b7a7de018b9a87371442.svg";